import React, { useState, ChangeEvent, useEffect } from 'react';
import FormInput from '../input/form-input';
import { InputProps } from '../input/form-input';
import Spacing from '../spacing/spacing';
import useTextAreaStyles from './textarea.style';

interface TextareaProps extends InputProps {
  inputRef?: React.RefObject<HTMLInputElement>;
  watch?: any;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const Textarea: React.FC<TextareaProps> = ({
  name,
  min = 10,
  max = 5000,
  inputRef,
  watch,
  value,
  onChange,
  ...props
}: TextareaProps) => {
  const [editedValue, setEditedValue] = useState(value);
  const [isMultiline, setIsMultiline] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { textarea__default, textarea__multiline, message__error, message } = useTextAreaStyles();
  const messageClass = hasError ? message__error : message;

  const classes = isMultiline
    ? { multiline: textarea__multiline, input: textarea__multiline }
    : { multiline: textarea__default, input: textarea__default };
  const rows = isMultiline ? 13 : 1;

  useEffect(() => {
    setIsMultiline(editedValue && editedValue.length > 0 ? true : false);
  }, [editedValue]);

  const onTextareaBlur = (event: ChangeEvent): void => {
    const target = event.target as HTMLTextAreaElement;
    const size = target.value && target.value.length;
    if (size >= min || size === 0) {
      setHasError(false);
    } else {
      setHasError(true);
    }
    setIsMultiline(size > 0);
  };

  const onTextareaFocus = (): void => {
    setIsMultiline(true);
  };

  const onTextareaChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    setEditedValue(event.target.value);
    onChange(event);
  };

  return (
    <>
      <FormInput
        {...props}
        max={max}
        name={name}
        data-testid={name}
        isDisplayLabel={false}
        multiline
        rows={rows}
        value={editedValue}
        onChange={onTextareaChange}
        onBlur={onTextareaBlur}
        classes={classes}
        onFocus={onTextareaFocus}
        ref={inputRef}
        hasError={hasError}
      />
      <Spacing variable="spacing-base" />
      <div className={messageClass}>
        {`${(editedValue && editedValue.length || 0)} / ${max}`}
      </div>
    </>
  );
};

export default Textarea;